import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getIn, setIn } from 'formik';

import SrUserSettingDropdown from 'client/components/SrUserSettingDropdown';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';

import UserActions from 'client/actions/User';
import {
  partnerFullServiceAgentSignupTypes,
  PARTNER_AGENT_SIGNUP_TYPE_SUNRISE,
  PARTNER_AGENT_SIGNUP_TYPE_TENANT_SCREENING,
} from 'common/partnerConstants';

const options = [
  {
    label: 'all',
    value: undefined,
  },
  {
    label: 'Full-Service',
    value: partnerFullServiceAgentSignupTypes,
  },
  {
    label: 'SunScreen',
    value: [PARTNER_AGENT_SIGNUP_TYPE_TENANT_SCREENING],
  },
  {
    label: 'SunSetup',
    value: [PARTNER_AGENT_SIGNUP_TYPE_SUNRISE],
  },
];

class SrUserSettingPartnerTypeDropdown extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    settingField: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      settingValue: getIn(props.currentUser.settings, props.settingField),
    };
  }

  _onUpdateSetting = (partnerType) => {
    const { settingValue } = this.state;

    // User selects "all"
    if (partnerType === undefined) {
      this.setState({ settingValue: undefined });
    }
    // User selects a different status and the current option is "all"
    else if (settingValue === undefined) {
      this.setState({ settingValue: partnerType });
    } else {
      this.setState({
        settingValue: settingValue.some((item) => partnerType.includes(item))
          ? settingValue.filter((option) => !partnerType.includes(option))
          : [...settingValue, ...partnerType],
      });
    }
  };

  _onSaveSettings = () => {
    const { currentUser, settingField, dispatch } = this.props;
    const { settingValue } = this.state;
    const newUserSettings = setIn({ ...currentUser.settings }, settingField, settingValue);
    dispatch(UserActions.updateSettings, newUserSettings);
  };

  render() {
    const { currentUser, settingField, dispatch } = this.props;

    const { settingValue } = this.state;

    const settingValueArray = Array.isArray(settingValue) ? settingValue : [settingValue];

    const optionsActive = options
      .filter(({ value }) =>
        Array.isArray(value)
          ? settingValueArray.includes(value[0])
          : settingValueArray.includes(value),
      )
      .map(({ label }) => label)
      .join(', ');
    const title = `Partner Type: ${optionsActive || 'all'}`;

    return (
      <SrUserSettingDropdown
        user={currentUser}
        settingField={settingField}
        settingValue={settingValue}
        title={title}
        options={options}
        onChange={this._onUpdateSetting}
        dispatch={dispatch}
        shouldUpdateSettings={false}
        multiple
        footer={
          <div className="buttonContainer">
            <ButtonDeprecated
              theme={BUTTON_THEME_BLUE}
              type="button"
              onClick={this._onSaveSettings}
            >
              save
            </ButtonDeprecated>
          </div>
        }
      />
    );
  }
}

SrUserSettingPartnerTypeDropdown.displayName = 'SrUserSettingPartnerTypeDropdown';

export default SrUserSettingPartnerTypeDropdown;
